import React, { FC, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import FhirLoader from '../../../../FhirLoader'
import { ProcedureBundle } from '../../../../../types/FHIRTypes/Bundle'
import { Procedure as FHIRProcedure } from '@teschglobal/tg-fhir-react-components/dist/types'
import { Procedure } from '@teschglobal/tg-fhir-react-components'
import useFhirConfig from '../../../../../hooks/admin/useFhirConfig'
import { UseQueryResult } from 'react-query'
import useFhirResourceById from '../../../../../hooks/admin/useFhirResourceById'


type ProcedureDetailProps = {
    procedureDetailId: string | undefined;
}

const ProcedureDetail: React.FC<ProcedureDetailProps> = ({ procedureDetailId}) => {


    const { patientAccessFhirConfig } = useFhirConfig()

      const {
    data: procedure,
    isFetching,
    isLoading,
    isError
  }: UseQueryResult<FHIRProcedure, Error> =
    useFhirResourceById('Patient Access', procedureDetailId || '', 'Procedure')

  if (isFetching || isLoading) {
    return <FhirLoader />
  }

  if (!procedure || isError) {
    return <div className='text-center' role='status' aria-live='polite' aria-atomic='true'>Not Found</div>
  }




  

    return (
        <section>
             <Procedure data={procedure} fhirApiConfig={patientAccessFhirConfig} />
        </section>
    )
}

export default ProcedureDetail